module.exports = __webpack_public_path__ + "img/服務條款6.4f1ee1b6.png";